import React, { useState, useCallback, ChangeEventHandler } from 'react';
import { StoreState } from './Store';

type InputOnChangeHandler = ChangeEventHandler<HTMLInputElement>;

export const useFilter = (): [string, InputOnChangeHandler] => {
    const [value, setValue] = useState<string>('');

    const onChange = useCallback<InputOnChangeHandler>((event) => {
        setValue(event.target.value);
        StoreState.set({ filter: event.target.value });
    }, []);

    return [value, onChange];
};

export const Filter: React.FC = () => {
    const [value, onChange] = useFilter();

    return (
        <div className="mb-5 mt-4">
            <form>
                <input type="search" value={value} onChange={onChange} placeholder="Filter for..." />
            </form>
        </div>
    );
};
